import React from 'react';
import eventHumanFriendlyDate from '../../../misc/eventHumanFriendlyDate';
import NotificationsBubble from '../NotificationsBubble';
import { useEventNotifications } from '../../../data/hooks/notifications/useEventNotifications';

const EventIcon = (props) => {
    const { event } = props,
        style = {
            backgroundColor: 'transparent',
            backgroundImage: 'url("' + event.icon_url + '")',
        },
        date = eventHumanFriendlyDate(event, event.start_utc, event.end_utc),
        notifications = useEventNotifications(event.id);

    return (
        <div>
            <div className="icon" style={style}>
                <NotificationsBubble>{notifications.length}</NotificationsBubble>
            </div>
            <div className="name">{event.name}</div>
            <div className="date">{date}</div>
        </div>
    );
};

export default EventIcon;
